import QuickfireWinCycle from "quickfire/states/quickfire-win-cycle";

export default class SGWinCycle extends QuickfireWinCycle {

    public onEnter(): void {
        super.onEnter();
    }

    public onExit(): void {
        super.onExit();
    }
}
